module.exports = __webpack_public_path__ + "static/media/question-mark.7ee511a7.svg";